import { createAction } from "@reduxjs/toolkit";

export const memberJoined = createAction<object>("webrtc/members/joined");
